import { LegendList, type LegendListProps, type LegendListRef } from "@legendapp/list";
import { sizeTokens } from "../themes/token-size";
import { Divider } from "./Divider";
export type ListRef = LegendListRef;
const estimatedItemSize = sizeTokens.si9;
export type ListProps<T> = LegendListProps<T> & {
  withDivider?: boolean;
};
function ListDivider() {
  return <Divider data-sentry-element="Divider" data-sentry-component="ListDivider" data-sentry-source-file="List.tsx" />;
}

/**
 * Light wrapper around Legend List.
 * @see https://legendapp.com/open-source/list/
 * Provides defaults for `recycleItems` (true) and `estimatedItemSize` (from theme tokens).
 */
export function List<T>({
  withDivider,
  ...rest
}: ListProps<T>) {
  return <LegendList {...withDivider ? {
    ItemSeparatorComponent: ListDivider
  } : {}} recycleItems={true} estimatedItemSize={estimatedItemSize} {...rest} data-sentry-element="LegendList" data-sentry-component="List" data-sentry-source-file="List.tsx" />;
}